import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useBonusGameQuery } from '@swf/core/hooks/useBonusGameQuery';
import useEmbeddedAPI from '@swf/core/hooks/useEmbeddedAPI';
import type { Dispatch, RootState } from '@swf/core/store';
import { dispatch, select } from '@swf/core/store';
import type { SpinOfDayData } from '@swf/core/types/CasinoBonus';

const useCasinoBonusGame = (): React.Dispatch<React.SetStateAction<SpinOfDayData | undefined>> => {
  const [game, setGame] = useState<SpinOfDayData>();
  const { modal } = useDispatch<Dispatch>();
  const site = useSelector(select.cms.getSiteId);
  const showTerms = site === Sites.UK;
  const tncVersion = useSelector(select.casino.sotdLatestVersion);
  const areTermsAccepted = useSelector((state: RootState) =>
    select.casino.acceptedSotdTermsAreCurrent(state, tncVersion)
  );
  const query = useBonusGameQuery(game);

  useEmbeddedAPI();

  useEffect(() => {
    const launchGame = () => {
      modal.enqueue({
        path: '/casino/game-overlay',
        locationState: { gameUrl: game?.gameURL, query, title: 'CasinoBonusGame' }
      });
      setGame(undefined);
    };

    if (!game) return;
    if (showTerms && !areTermsAccepted) {
      dispatch.modal.enqueue({
        path: '/casino/help',
        locationState: {
          isSotd: true,
          acceptanceRequired: true,
          version: tncVersion,
          onClose: () => {
            setGame(undefined);
          }
        }
      });
    } else {
      launchGame();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game, showTerms, areTermsAccepted, tncVersion]);

  return setGame;
};

export default useCasinoBonusGame;
